export default __webpack_public_path__ + "static/audio-cardio-2-b-190e695dc529d974e8d96f8e5c0d787a.webp";